<i18n>
{
    "ru": {
        "signin": "Войти",
        "gift_description": "Зарегистрируйтесь и получите свои первые <span class='bolder'>20 бонусных миллилитров</span>, которые вы сможете обменять на скидку в партнёрском магазине <span class='header__tooltip-link'>Randewoo</span>!",
        "detail": "Подробнее"
    }
}
</i18n>

<template>
    <header :class="headerClasses" class="header">

        <div class="header__burger" @click="openSidebar">
            <svg-icon name="sidebar-opener" class="header__burger-icon" />
        </div>

        <div class="header__col">
            <router-link to="/" 
                aria-label="Aromo.ru"
                class="header__logo">
                <!-- eslint-disable-next-line -->
                <svg class="header__logo-svg header__logo-svg_ru" width="91" height="15" viewBox="0 0 91 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <!-- eslint-disable-next-line -->
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M89.02 12.918c-1.326 1.305-3.132 1.957-5.418 1.957-1.496 0-2.794-.293-3.895-.877a5.96 5.96 0 0 1-2.532-2.553c-.588-1.116-.881-2.437-.881-3.96 0-1.567.293-2.908.881-4.025A6.058 6.058 0 0 1 79.707.892C80.808.297 82.107 0 83.602 0c1.538 0 2.858.297 3.959.892a6.166 6.166 0 0 1 2.548 2.568c.598 1.117.897 2.458.897 4.024 0 2.317-.662 4.129-1.986 5.434Zm-2.26-9.082c-.695-.846-1.748-1.268-3.158-1.268-1.346 0-2.367.422-3.062 1.268-.694.845-1.04 2.062-1.04 3.648 0 1.565.346 2.766 1.04 3.601.695.836 1.716 1.253 3.062 1.253 1.41 0 2.463-.417 3.158-1.253.694-.835 1.04-2.036 1.04-3.6 0-1.587-.346-2.804-1.04-3.65Zm-19.188 8h1.314v-5.73c0-1.253-.214-2.14-.64-2.662-.428-.522-1.155-.783-2.18-.783-.556 0-1.127.1-1.715.298-.588.199-1.053.454-1.394.767v8.11h1.314v2.506h-5.898v-2.505h1.346V6.106c0-1.253-.208-2.14-.625-2.662-.417-.522-1.138-.783-2.163-.783-.556 0-1.128.1-1.715.298-.59.199-1.064.454-1.427.767v8.11h1.346v2.506h-7.244v-2.505h2.66V3.632l-3.044-.97.833-2.506 4.455 1.44A7.572 7.572 0 0 1 54.96.423 7.15 7.15 0 0 1 57.347 0c.962 0 1.822.146 2.58.438.759.293 1.373.72 1.843 1.284.598-.502 1.315-.913 2.148-1.237A6.939 6.939 0 0 1 66.45 0c1.987 0 3.424.454 4.31 1.361.887.91 1.33 2.386 1.33 4.432v6.044h2.726v2.505h-7.245v-2.505Zm-28.816 3.039c-1.496 0-2.794-.293-3.895-.877a5.96 5.96 0 0 1-2.532-2.553c-.588-1.116-.881-2.437-.881-3.96 0-1.567.293-2.908.881-4.025A6.058 6.058 0 0 1 34.861.892C35.962.297 37.261 0 38.756 0c1.538 0 2.858.297 3.959.892a6.167 6.167 0 0 1 2.548 2.568c.598 1.117.897 2.458.897 4.024 0 2.317-.662 4.129-1.986 5.434-1.326 1.305-3.132 1.957-5.418 1.957Zm3.158-11.04c-.695-.845-1.748-1.267-3.158-1.267-1.346 0-2.367.422-3.062 1.268-.694.845-1.04 2.062-1.04 3.648 0 1.565.346 2.766 1.04 3.601.695.836 1.716 1.253 3.062 1.253 1.41 0 2.463-.417 3.158-1.253.694-.835 1.04-2.036 1.04-3.6 0-1.587-.346-2.804-1.04-3.65ZM26.996 2.819a9.046 9.046 0 0 0-2.02.344 6.056 6.056 0 0 0-1.666.752l-.033 7.923h3.142v2.505h-9.04v-2.505h2.693V3.694l-3.077-1.001.865-2.537 4.552 1.503A9.948 9.948 0 0 1 24.96.454a8.922 8.922 0 0 1 2.58-.392c.79 0 1.421.094 1.892.282l.545 3.633-2.66.564-.321-1.723ZM10.45 13.591c-1.453.855-2.97 1.284-4.552 1.284-1.923 0-3.381-.367-4.375-1.097C.53 13.048.022 11.983 0 10.584c-.021-2.86 1.87-4.29 5.674-4.29l3.782.032c0-1.316-.262-2.292-.785-2.929-.524-.636-1.256-.955-2.196-.955-.492 0-.961.031-1.41.094a8.15 8.15 0 0 0-1.282.282l-.321 1.628-2.66-.407.577-3.131A16.645 16.645 0 0 1 3.91.235 14.16 14.16 0 0 1 6.476 0c2.03 0 3.574.527 4.632 1.581 1.058 1.055 1.587 2.605 1.587 4.65v5.293l2.82.908L14.682 15l-4.231-1.41Zm-.994-5.074H5.77c-.79 0-1.4.172-1.827.517-.428.345-.641.841-.641 1.488 0 1.294.908 1.941 2.725 1.941 1.282 0 2.425-.333 3.43-1.002V8.517Z" fill="#141414"/>
                </svg>
            </router-link>
        </div>

        <div class="header__col">

            <AppMainMenu v-if="viewDesktop" />

            <div v-if="!viewDesktop"
                :class="notifyClasses"
                class="header__notify">
                <svg-icon @click="showNotices"
                    name="icon-bell"
                    class="header__notify-icon" />
            </div>

            <client-only>
                <router-link class="header__profile"
                    aria-label="User"
                    :to="`/users/${currentUserId}`"
                    v-if="!viewDesktop && userLoggedIn">
                    <svg-icon name="icon-user" class="header__profile-icon" />
                </router-link>
                <!-- <router-link class="header__profile"
                    to="/logout"
                    v-if="$auth.loggedIn">
                    <svg-icon name="header-signin" class="header__signin-icon" />
                </router-link> -->
                <span v-if="!viewDesktop && !userLoggedIn"
                    class="header__signin"
                    @click.prevent="showPopup('signin')">
                    <svg-icon name="header-signin" class="header__signin-icon" />
                </span>
            </client-only>

        </div>

        <div v-if="viewDesktop" class="header__col">
            <client-only>
                <div
                    :class="notifyClasses"
                    tabindex="0"
                    @mouseleave="closeNoticesDesktop"
                    @mouseenter="showNotices"
                    class="header__notify"
                    v-if="userLoggedIn">
                    <router-link :to="{name: 'Notifications', 'params': {'userId': currentUserId}}"
                        aria-label="Notifications"
                        class="header__notify-link">
                        <svg-icon name="icon-bell"
                            class="header__notify-icon" />
                    </router-link> 
                    <Notices class="header__popup-notices"
                        without-modal
                        v-if="notices"
                        :is-showed-desktop="isShowNoticesDesktop"
                        :data-visible="isShowNoticesDesktop"
                        @noticeClick="isShowNoticesDesktop = false"
                        :modalItems="notices"
                        :show-more-is-active="showMoreNoticiesButton" />
                </div>

                <div class="header__profile header__desktop-profile"
                    v-if="userLoggedIn"
                    @mouseleave="closeProfileMenuDesktop"
                    @mouseenter="triggerProfileMenuDesktop">

                    <router-link class="header__profile header__picture-wrapper"
                        :to="`/users/${currentUserId}`"
                        tabindex="0"
                        aria-label="User">
                        <img
                            alt=""
                            v-if="get($auth, 'user.photo', null)"
                            v-lazy-load :data-src="get($auth, 'user.photo.url', getNoImage)"
                            class="header__profile-picture" />
                        <PlaceholderImage
                            v-else
                            is-circle
                            icon-name="placeholder-profile"/>
                    </router-link>

                    <AppHeaderProfileMenu
                        @click="showProfileMenuDesktop = false"
                        :data-visible="showProfileMenuDesktop"
                        class="header__profile-menu" />

                </div>

                <div v-else
                    class="header__signin-wrapper">

                    <span class="header__link header__signin_desktop">
                        {{ $t('signin') }}
                    </span>

                    <span class="header__separator header__separator_signin"></span>

                    <div class="header__registration">
                        <svg-icon name="icon-gift"
                            class="header__registration-icon header__registration-icon_gift" />
                    </div>

                    <html-link to="/help/bonus-program/#kak-i-na-chto-potratit-millilitry" 
                        class="header__registration-tooltip">
                        <!-- eslint-disable-next-line -->
                        <p v-html="$t('gift_description')"></p>
                        <span class="link header__tooltip-link"> {{ $t('detail') }} </span>
                    </html-link>
                    <span class="header__signin-link" @click.prevent="showPopup('signin')"></span>
                </div>
            </client-only>
        </div>
    </header>
</template>

<script>
import get from 'lodash/get';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import AppMainMenu from '@/components/layout/AppMainMenu';
import User from "~/models/users/User";

export default {
    name: 'AppHeader',
    serverCacheKey(props) {
        return 'desktop:' + props.viewDesktop;
    },
    components: {
        Notices: () => import('@/components/modal/ui/Notices'), 
        AppHeaderProfileMenu: () => import('@/components/layout/blocks/AppHeaderProfileMenu'), 
        AppMainMenu, 
        PlaceholderImage: () => import('@/components/ui/PlaceholderImage')
    },
    props: {
        viewDesktop: {
            type: Boolean,
            default: false
        }
    },
    fetchOnServer: false,
    fetch() {
        this.userIsAuthorized = this.$auth.userLoggedIn();
        if (this.$auth.userLoggedIn()){
            this.queryUserBroadcasts();
        }
    },
    data() {
        return {
            showProfileMenuDesktop: false,
            isShowNoticesDesktop: false,
            notices: [],
            showGiftDescription: true,
            showMoreNoticiesButton: false,
            userIsAuthorized: false
        }
    },
    globalBus: {
        'ws-message'(message) {
            switch (message.text.command) {
            case 'broadcastUpdated':
                this.$fetch();
                break;
            case 'notificationCreated':
                this.getNotifications();
                break;
            }
        },
        'auth-complete'() {
            this.userIsAuthorized = this.$auth.userLoggedIn();
            this.$fetch();
        },
        'user-logout'() {
            this.userIsAuthorized = false;
            this.notices = [];
        },
        'notices-update'(listItems) {
            this.$set(this, 'notices', listItems);
            this.queryUserBroadcasts()
        },
        'notices-set-viewed'() {
            this.queryUserBroadcasts()
        }
    },
    computed: {
        ...mapGetters(['getNoImage', 'getUserBroadcasts']),
        headerClasses() {
            return {
                'header__desktop': this.viewDesktop
            }
        },
        notifyClasses() {
            return {
                'header__notify_desktop': this.viewDesktop,
                'header__notify_unread': this.unreadNoticiesCounter > 0
            }
        },
        currentUserId() {
            return this.$auth.user.id
        },
        unreadNoticiesCounter(){
            return get(this.getUserBroadcasts, 'notifications.unread.total', null)
        },
        userLoggedIn() {
            return this.userIsAuthorized;
        }
    },
    mounted() {
        if (!this.$auth.userLoggedIn()) {
            this.notifyUnread = !this.$auth.$storage.getLocalStorage('guestNotificationReaded');
        }
    },
    methods: {
        get,
        ...mapActions(['queryUserBroadcasts']),
        ...mapMutations(['setUserBroadcasts']),
        async showNotices() {
            if (this.$auth.userLoggedIn()) {

                if (!this.notices.length)
                    await this.getNotifications()

                if(this.viewDesktop){
                    this.isShowNoticesDesktop = !this.isShowNoticesDesktop
                }else{
                    this.triggerPopup('notices', {
                        modalItems: this.notices,
                        showMoreIsActive: this.showMoreNoticiesButton
                        // showClose: false
                    })
                }
            } else {
                if (this.viewDesktop) {
                    this.isShowNoticesDesktop = !this.isShowNoticesDesktop;
                } else {
                    this.triggerPopup('notices', { auth: true });
                }

                this.$auth.$storage.setLocalStorage('guestNotificationReaded', true);
            }

        },
        async getNotifications() {
            const user = new User;
            const result = await user.notifications().where('per_page', '4').get()
            const notices = get(result, '[0].items', [])

            if (notices.length > 3) {
                this.showMoreNoticiesButton = true
                notices.pop()
            }

            this.notices = notices
        },
        triggerProfileMenuDesktop() {
            this.showProfileMenuDesktop = !this.showProfileMenuDesktop;
        },
        closeProfileMenuDesktop() {
            setTimeout(() => {
                this.showProfileMenuDesktop = false;
            }, 100)
        },
        closeNoticesDesktop() {
            setTimeout(() => {
                this.isShowNoticesDesktop = false;
            }, 100)
        },
        openSidebar(){
            this.$bus.$emit('open-sidebar')
        }
    }
}
</script>

<style lang="less">
.header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    background-color: @color-white;
    border-bottom: rem(1) solid @color-gray-white;
    box-sizing: border-box;

    padding: 0 pxToRem(20);

    height: @header-height-mobile;
    width: 100vw;

    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;

    .fixed-header-hidden &{
        position: fixed;
        visibility: hidden;
        transform: translateY(-100%);
    }

    .fixed-header &{
        position: fixed;
        transform: translateY(-100%);
        visibility: visible;
        transition: transform .15s ease;
    }

    .fixed-header.fixed-header-show &{
        transform: translateY(0);
    }

    [data-cutted="true"] & {
        transform: none;
        visibility: visible;
    }

    @{desktop} & {
        border-bottom: none;

        margin: rem(10) auto;
        padding: 0 rem(20);

        width: @widthWrapperDesktop;

        position: relative;
    }

    &__col {
        display: flex;
        flex-direction: row;
        align-items: center;

        &:first-child{
            @{desktop} & {
                width: rem(131);
            }
        }

        &:last-child{
            @{desktop} & {
                width: rem(120);
            }
        }
    }

    &__link {
        cursor: pointer;
    }

    &__logo {
        margin-left: pxToRem(42);

        &-svg {
            display: block;

            height: 100%;

            &_ru{
                height: pxToRem(15);
                width: pxToRem(92);

                @{desktop} & {
                    height: pxToRem(22);
                    width: pxToRem(131);
                }
            }

            &_en{
                height: pxToRem(17);
                width: pxToRem(113);
            }
        }

        @{desktop} & {
            margin-bottom: rem(1);
            margin-left: 0;
        }
    }

    &__notify {
        outline: none;

        margin-right: pxToRem(22);

        position: relative;

        &-icon{
            height: rem(20);
            width: rem(20);
        }

        &-link{
            display: block;
            height: rem(20);
            width: rem(20);
            position: relative;
            z-index: 11
        }

        &_unread {
            &:after {
                content: '';
                display: block;

                background-color: @color-primary;
                border: 2px solid @color-white;
                border-radius: 50%;

                height: rem(10);
                width: rem(10);

                position: absolute;
                top: 0;
                right: rem(1);

                @{desktop} & {
                    top: rem(3);
                    right: rem(3);
                }
            }
        }

        &_desktop {
            margin-right: rem(26);
            margin-left: rem(20);
            padding: rem(7);

            top: rem(-1);
        }
    }

    &__profile {
        color: @color-black;
        outline: none;

        padding: rem(5) 0;

        position: relative;
        z-index: 1;

        &-icon{
            height: pxToRem(18);
            width: pxToRem(18);
        }
    }

    &__profile-picture {
        object-fit: cover;

        border-radius: 50%;

        height: rem(40);
        width: rem(40);
    }

    &__profile-menu {
        background: @color-white;
        box-shadow: @menu-desktop-box-shadow-light;
        outline: none;

        min-width: rem(230);

        position: absolute;
        top: rem(57);
        right: rem(-10);

        visibility: hidden;
        opacity: 0;
        .animate(opacity);

        &:before{
            content: '';
            display: block;

            background: transparent;
            
            height: 20px;
            width: 100%;

            position: absolute;
            top: -20px;
            left: 0;
        }

        &[data-visible] {
            visibility: visible;
            opacity: 1;
        }
    }

    .header__col{
        &:last-child{
            @{mobile} & {
                min-width: rem(60);
            }
        }
    }

    &__signin {
        min-width: rem(18);
        min-height: rem(1);
        display: block;
        transform: translateY(rem(-2));

        &-wrapper {
            display: flex;
            align-items: center;
            cursor: pointer;

            border-radius: rem(3);
            box-shadow: @menu-desktop-box-shadow;

            margin-left: auto;
            padding: rem(9) rem(12) rem(8);

            position: relative;
            .animate(box-shadow);

            &:hover {
                box-shadow: @menu-desktop-box-shadow-hover;

                &:before {
                    content: '';
                    display: block;

                    height: rem(20);
                    width: 100%;

                    position: absolute;
                    bottom: rem(-10);
                    left: 0;
                }
            }

            &:hover > .header__registration-tooltip {
                display: block;

                visibility: visible;
                opacity: 1;
            }
        }

        &-icon {
            margin-top: rem(4);

            height: rem(18);
            width: rem(18);

        }

        &-link {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
        }

        &_desktop {
            color: @color-primary;
            font-size: rem(15);
            font-weight: 500;
        }
    }

    &__registration {
        margin-right: rem(-1);
        margin-bottom: rem(2);

        &-icon {
            margin-left: rem(-4);

            height: rem(24);
            width: rem(22);

            &_gift {
                cursor: pointer;

                color: @color-primary;

                height: rem(16);
                width: rem(19);
            }
        }
    }

    &__registration-tooltip {
        display: block;

        background: @color-white;
        border-radius: rem(3);
        box-shadow: @menu-desktop-box-shadow-light;
        font-size: rem(15);

        padding: rem(20) rem(20) rem(24) rem(20);

        min-width: rem(350);

        position: absolute;
        top: rem(50);
        right: 0;

        visibility: hidden;
        color: @color-black;
        opacity: 0;
        .animate(opacity);
        transition-delay: 0.1s;

        &:hover {
            visibility: visible;
            opacity: 1;
        }

        a {
            color: @color-primary;
            text-decoration: none;
        }

        .bolder {
            font-weight: 500;
        }
    }

    &__tooltip-link{
        color: @color-violet;
    }

    &__separator {
        display: block;

        background: @color-gray-white;

        margin-right: rem(13);
        margin-left: rem(13);

        height: rem(20);
        width: rem(1);
    }

    &__popup-notices {
        background: @color-white;
        border-radius: rem(3);
        box-shadow: @menu-desktop-box-shadow-medium-light;
        outline: none;

        width: rem(375);

        position: absolute;
        top: rem(44);
        right: rem(-73);

        visibility: hidden;
        opacity: 0;
        .animate(opacity);

        &:before{
            content: '';
            display: block;
            position: absolute;
            left: 0;
            right: 0;
            height: 20px;
            top: -20px;
            background: transparent;
        }

        &[data-visible] {
            z-index: 10;

            visibility: visible;
            opacity: 1;
        }
    }

    &__picture-wrapper {
        overflow: hidden;

        .placeholder-image {
            max-height: rem(40);
            max-width: rem(40);

            overflow: hidden;
        }
    }

    &__burger{
        display: block;

        line-height: rem(30);
        text-align: center;

        height: rem(30);
        width: rem(30);

        position: absolute;
        top: rem((56-30)/2);
        left: rem(16);

        transition: visibility 0s .19s linear;

        pointer-events: auto;

        &-icon{
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;

            height: rem(20);
            width: rem(20);
        }

        @{desktop} & {
            display: none;
        }
    }
}
</style>
